module.exports = __webpack_public_path__ + "static/media/logo-cn-processed-steel-200x161.4541fa6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-cn-processed-steel-200x161.jpg
// module id = 697
// module chunks = 0